module.exports = __webpack_public_path__ + "img/check-green.b315cb87.svg";